//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
let d=[[[1,"BeltThickness",0,"Expression",0],[0,"BuildStatus",0,0],[0,"DesignStatus",1,0],[0,"DisplayStatus",1,0],[1,"ExtensionDistance",0,"Expression",0],[0,"ExtensionType",1,0],[0,"InsertType",1,0],[1,"ProfileRelief",0,"Expression",0],[0,"ProfileReliefToggle",1,0],[1,"ReliefAngle",0,"Expression",0],[0,"SegDirection",1,"Direction",0],[0,"SegPoint",1,"IOrientation",0]],[[["belt_thickness"],"SetBeltThickness",{},1,0],[["relief_angle"],"SetReliefAngle",{},1,0],[["profile_relief"],"SetProfileRelief",{},1,0],[["extension_distance"],"SetExtensionDistance",{},1,0]],[]];
SPLM.Die.SteelInsertSegmentChildBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.SteelInsertSegmentChildBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.SteelInsertSegmentChildBuilder.InsertTypeOption = Object.freeze({
    "Trim" : "Trim", "Flange" : "Flange", "OffsetFlange" : "OffsetFlange"});

SPLM.Die.SteelInsertSegmentChildBuilder.ExtensionTypeOption = Object.freeze({
    "Constant" : "Constant", "MaxdistPlusConst" : "MaxdistPlusConst", "Law" : "Law"});

export default SPLM;